import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBaseResponse } from '../../utilities/http-utilities.service';

export type TPinEntityType = 'dashboard' | 'slideshow';

export interface IUserPinToggleResult {
  isPinned: boolean;
}

@Injectable({ providedIn: 'root' })
export class UserPinService {
  constructor(private readonly http: HttpClient) {}

  public toggle(entityType: TPinEntityType, entityId: number): Observable<IBaseResponse<IUserPinToggleResult>> {
    return this.http.post<IBaseResponse<IUserPinToggleResult>>('user-pins/toggle', { entityId, entityType });
  }
}
